import { Product } from 'core/types/product';

export const SET_CUSTOMER_PRODUCTS = 'SET_CUSTOMER_PRODUCTS';

export class SetCustomerProducts {
  readonly type = SET_CUSTOMER_PRODUCTS;
  readonly payload: {
    customer: number;
    products: Array<Product & { pivot: { price: number } }>;
  };

  constructor(
    customer: number,
    products: Array<Product & { pivot: { price: number } }>
  ) {
    this.payload = { customer, products };
  }
}

export type Action = SetCustomerProducts;
